import styled from '@emotion/styled';
import { Card, Stack, tokens } from '@hotjar/hotsauce';

export const DataLimitsCardStyles = {
  DataLimitsCard: styled('div')`
    border: 1px solid ${tokens.color.neutral_400};
    border-radius: ${tokens.radius.m};
    padding: ${tokens.spacer.x2};
  `,
  DataLimitsRow: styled(Stack)`
    justify-content: space-between;
  `,
  Widget: styled(Card)<{ warning: boolean; success: boolean; isLoading: boolean }>`
    box-shadow: none;
    padding: 12px 16px 12px 16px;
    border: 1px solid ${tokens.ALIAS_COLORS.ui_border};
    background-color: ${tokens.ALIAS_COLORS.bg_info};

    ${(props) =>
      props.warning &&
      `
      border: 1px solid ${tokens.ALIAS_COLORS.ui_border_warning};
      background-color: ${tokens.ALIAS_COLORS.bg_warning};
    `}
    ${(props) =>
      props.success &&
      `
      border-color: 1px solid ${tokens.ALIAS_COLORS.ui_border_success};
      background-color: ${tokens.ALIAS_COLORS.bg_success};
    `}

    ${(props) =>
      props.isLoading &&
      `
      border: none;
      background-color: ${tokens.ALIAS_COLORS.bg_info};
    `}
  `,
  LoadingWidgetBody: styled(Stack)`
    justify-content: center;
  `,
};
